import { render, staticRenderFns } from "./DiscoveryContent.vue?vue&type=template&id=9979aade&scoped=true&"
import script from "./DiscoveryContent.vue?vue&type=script&lang=js&"
export * from "./DiscoveryContent.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryContent.vue?vue&type=style&index=0&id=9979aade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9979aade",
  null
  
)

export default component.exports